import React, { useState } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import {
  packageAssign
} from "actions/chargers/package/actions";

const AssignToUser = ({
                        packageAssign,
                        packageId,
                        onCancel,
                      }) => {
  const [usersList, setUsersList] = useState("");
  const [hasError, setHasError] = useState(false);

  const handleChange = ({ target: { value } }) => {
    setUsersList(value);
  };

  const handleSubmit = () => {
    const submitValue = usersList
      .split(",")
      .map(v => v.trim())
      .join(" ")
      .split(" ")
      .filter(v => !!v);
    if (!submitValue.length) {
      setHasError(true);
      return;
    }
    packageAssign(packageId, submitValue);
    onCancel();
  };

  return (
    <div className="row">
      <div className="col-12">
        <div className="form-group">
          <label>Users list</label>
          <textarea
            className={`form-control ${hasError ? "is-invalid" : ""}`}
            value={usersList}
            onChange={handleChange}
          />
          <small className="form-text text-muted">
            User list should be separated by comma(,) or space( )
          </small>
          {hasError && (
            <div className="invalid-feedback">
              Provided data is invalid. Please provide correct data.
            </div>
          )}
        </div>
      </div>

      <div className="col-12">
        <div className="text-right mt-2">
          <button
            className="btn btn-danger mr-2"
            onClick={onCancel}
          >
            Cancel
          </button>
          <button
            className="btn btn-success"
            onClick={handleSubmit}
          >
            Save
          </button>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = state => ({
  packageImage: state.chargerPackage.packageImage,
});

const mapStateToDispatch = dispatch => ({
  packageAssign: bindActionCreators(packageAssign, dispatch),
});

export default connect(
  mapStateToProps,
  mapStateToDispatch
)(AssignToUser);



// WEBPACK FOOTER //
// ./src/views/pages/chargers/package/assign-to-users.js